module.exports = __webpack_public_path__ + "static/Riverside_cap-b1d1d6579ac36b1873f902e1e4dbc7a9.png";